var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const mockSpellsApi = {
    list: (params) => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve) => setTimeout(() => resolve([]), 300));
    }),
    update: (params, spell) => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve) => setTimeout(() => resolve({}), 200));
    }),
};
export const mockCharacterSpellsCollectionApi = {
    list: (params) => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve) => setTimeout(() => resolve([]), 300));
    }),
    create: (spellsCollection) => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve) => setTimeout(() => resolve({}), 200));
    }),
    update: (spellsCollection) => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve) => setTimeout(() => resolve({}), 200));
    }),
    delete: (id) => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve) => setTimeout(() => resolve(), 200));
    }),
};
